import { useState } from "react";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker"
import { differenceInDays, format } from "date-fns";
import { useLoading } from "../../../hooks/useLoading";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { HistoryBatches } from "./HistoryBatches";

export function HistoryImportTab() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [batchId, setBatchId] = useState('');
  const [batches, setBatches] = useState([]);
  const [exportingBatchId, setExportingBatchId] = useState(null);

  const loading = useLoading()

  async function handleSearchBatches() {
    if (!startDate || !endDate) {
      return toast.warning("Informe uma data inicial e uma data final")
    }
    const intervalDays = differenceInDays(endDate, startDate);

    if (intervalDays < 0) {
      return toast.warning("A data final deve ser maior que a data inicial")
    }

    if (intervalDays > 30) {
      return toast.warning("O intervalo de datas não deve ser superior a 30 dias")
    }

    const formattedStartDate = format(startDate, 'dd/MM/yyyy');
    const formattedEndDate = format(endDate, 'dd/MM/yyyy');

    try {
      loading.setLoading(true)
      const response = await api.get("produto/v1/busca_lote_importacao/", {
        params: {
          id_lote: batchId || null,
          data_inicio: formattedStartDate,
          data_fim: formattedEndDate
        }
      })

      const batches = response.data.results
      console.log(batches);

      setBatches(batches)

      if (!batches.length) {
        toast.warning("Nenhum lote encontrado")
      }

      loading.setLoading(false)
    } catch (error) {
      loading.setLoading(false)
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Falha no carregamento dos dados.");
      }
    }
  }

  async function handleExportBatchDetails(batchId) {
    try {
      setExportingBatchId(batchId);
      const response = await api.get("produto/v1/exporta_lote_importacao/", {
        params: {
          id_lote: batchId
        },
        responseType: "blob"
      })

      // Access headers.content-disposition to get the file name
      const contentDisposition = response.headers["content-disposition"];

      let fileName = `log_importacao_lote_${batchId}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      console.log(url);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      setExportingBatchId(null);
    } catch (error) {
      setExportingBatchId(null);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Falha ao exportar os detalhes do lote.");
      }
    }
  }

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title className="w-100 fw-bold fs-4">
            <h4>Histórico de Alterações</h4>
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Utilize esta funcionalidade para consultar as alterações realizadas.
          </Card.Subtitle>
        </Card.Header>

        <Card.Body>
          <Row className="align-items-end bg-light">
            <Col>
              <Form.Label htmlFor="dtaInicio">Data Inicial</Form.Label>
              <DatePicker
                id="dtaInicio"
                showIcon
                icon="fa fa-calendar"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control"
                locale="pt"
                popperClassName="custom-react-datepicker-z-index"
                dateFormat="dd/MM/yyyy"
              />
            </Col>
            <Col>
              <Form.Label htmlFor="dtaFim">Data Final</Form.Label>
              <DatePicker
                id="dtaFim"
                showIcon
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="form-control"
                locale="pt"
                popperClassName="custom-react-datepicker-z-index"
                dateFormat="dd/MM/yyyy"
              />
            </Col>
            <Col>
              <Form.Label htmlFor="idLote">Lote</Form.Label>
              <Form.Control
                type="text"
                id="idLote"
                value={batchId}
                onChange={(e) => setBatchId(e.target.value.replace(/\D/g, ''))}
                placeholder="Informe código do lote de importação"
              />
            </Col>
            <Col sm={2}>
              <Row className="justify-content-end">
                <Button
                  type="button"
                  variant="primary"
                  onClick={handleSearchBatches}
                  disabled={loading.isLoading}
                  className="min-w-25"
                >
                  {loading.isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        className="me-2"
                      /> {" "}
                      Pesquisando...
                    </>
                  ) : (
                    'Pesquisar'
                  )}
                </Button>
              </Row>
            </Col>
          </Row>
        </Card.Body>

        <Card.Body className="border-top border-secondary-subtle">
          <HistoryBatches
            batches={batches}
            loading={loading}
            exportingBatchId={exportingBatchId}
            handleExportBatchDetails={handleExportBatchDetails}
          />
        </Card.Body>
      </Card>
    </>
  )
}
